import PropertyBidCard from "@/Components/PropertyBigCard"
import { useAppSelector } from "@/store/hooks"
import { allPieces } from "@/utils/data"
import { mapDesigns } from "@mono/mapDesigns"
import { useEffect } from "react"
import bankruptHappyAudioSrc from "@/audio/bankruptHappy.mp3"
import bankruptSadAudioSrc from "@/audio/bankruptSad.mp3"
import { getUserCreds } from "@/utils/utils"
import { createEffectAudio } from "@/utils/audioManager"

export const BankruptNotification: React.FC<BankruptNotificationProps> = ({
  creditorOrder,
  playerOrder,
}) => {
  const myGameSituation = useAppSelector((state) => state.global.myGame?.situation)
  const myGamePlayers = useAppSelector((state) => state.global.myGame?.players)
  
  const winnerId = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  )?.id
  const user = myGamePlayers?.find((user) => user.email === winnerId)
  const player = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  ) as IPlayer
  const piece = allPieces.find((item) => item.id === player.pieceId)
  const currentPlayer = myGameSituation?.players.find(
    (p) => p.id === getUserCreds().email
  )
  useEffect(() => {
    const bankruptHappyAudio = createEffectAudio(bankruptHappyAudioSrc)
    const bankruptSadAudio = createEffectAudio(bankruptSadAudioSrc)
    if (playerOrder === currentPlayer?.order) {
      bankruptSadAudio.play()
    } else {
      bankruptHappyAudio.play()
    }
  }, [playerOrder, currentPlayer])
  return (
    <>
      <div
        data-testid="notification.bankrupt"
        className="fixed top-1/2 left-1/4 z-[100] -translate-y-1/2 -translate-x-full"
      ></div>
      <div className="fixed top-1/2 items-center gap-5 -translate-y-1/2 w-full py-10 font-semibold shadow-centerCardGlowRed border-red-500 border-t-4 border-b-4 flex justify-center text-5xl z-20 text-white font-poppins bg-[rgba(0,0,0,0.8)] ">
        <div className="flex items-center gap-4">
          <img src={piece?.imgSrc} className="h-11 w-11"></img>
          <div className="flex flex-col gap-2">
            <div className="">{user?.username}</div>
          </div>
        </div>
        Declared Bankruptcy
      </div>
    </>
  )
}
